import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { NOTIFICATION_TYPES } from '../../../constants';

type UseStarterCanEmailDm =
	| {
			type: (typeof NOTIFICATION_TYPES)['emailDecisionMaker'];
	  }
	| undefined;

export function useEmailDecisionMaker(): UseStarterCanEmailDm {
	const {
		data: {
			petition: {
				decisionMakersConnection: { nodes: decisionMakers },
			},
		},
	} = useStarterDashboardV2PageData();

	const isAnEmailPresent = !!decisionMakers.find((dm) => !!dm.email);

	// ALERTS: comment this line
	if (!isAnEmailPresent) return undefined;

	return { type: NOTIFICATION_TYPES.emailDecisionMaker };
}
